const list = state => state.faq;

export default {
  list,
};
